import React from "react";
import { Table, Tag, Popconfirm } from "antd";
import { ColumnType } from "antd/es/table";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FiEdit3 } from "react-icons/fi";
import { IRegisteredUserListResponse } from "../../../types/api/users-manage";
import { renderIcon, renderTableText } from "../../../lib/utils";
import ManageUserCard from "../../components/reuseComp/ManageUserCard";
import MyPagination from "../../../views/components/Pagination";
import { useNavigate } from "react-router-dom";

interface ManageUserTableProps {
  data?: IRegisteredUserListResponse[];
  handleDelete?: (id: string) => void;
  loading?: boolean;
  DEFAULT_NUQS_CONFIG?: any;
  qData?: any;
  refetch?: any;
}

const EditIcon = renderIcon(FiEdit3);
const DeleteIcon = renderIcon(RiDeleteBin6Line);

const ManageUserTable: React.FC<ManageUserTableProps> = ({
  data = [],
  handleDelete = () => {},
  loading = false,
  DEFAULT_NUQS_CONFIG,
  qData,
  refetch,
}) => {

  const navigate = useNavigate();


  const columns: ColumnType<IRegisteredUserListResponse>[] = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_,v) => <p>
        {v?.email}
       <span className="font-semibold text-primary"> {v?.name ? ` (${v?.name})` : ""} </span>
      </p>,
      width:350,
    
    },
    // {
    //   title: "Role",
    //   dataIndex: "role",
    //   key: "role",
    //   render: (v) => renderTableText(v),
    // },
    // {
    //   title: "Assigned Jobs",
    //   dataIndex: "assignedJobsCount",
    //   key: "assignedJobsCount",
    //   render: (v) => renderTableText(v),
    // },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status: boolean) => (
        <Tag color={status ? "green" : ""} bordered>
          {status ? "Active" : "Inactive"}
        </Tag>
      ),
    },

    {
      title: "Action",
      key: "action",
      align: "right",
      render: (_: any, row: any) => (
        <div className="flex items-center justify-end gap-3 pr-3">
          <EditIcon
            className="cursor-pointer text-primary text-[20px]"
            onClick={() => navigate(`/users/edit/${row?._id}`)}
          />

          <Popconfirm
            title="Are you sure to delete this row?"
            onConfirm={() => handleDelete?.(row?._id)}
            okText="Yes"
            cancelText="No"
          >
            <DeleteIcon className="cursor-pointer text-primary hover:text-red-600 text-[20px]" />
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div>
      {/* Desktop Table */}
      <div className="hidden md:block">
        <Table
          dataSource={data || []}
          columns={columns}
          rowKey={(item: any) => item?._id}
          pagination={false}
          size="middle"
          bordered={false}
          loading={loading}
          className="custom-table-class rounded-lg border border-gray-200 shadow-md"
          footer={() => <MyPagination qData={qData} onChange={refetch} total={qData.total} DEFAULT_NUQS_CONFIG={DEFAULT_NUQS_CONFIG} />}
        />
      </div>

      {/* Mobile View */}
      <div className="grid gap-4 md:hidden">
        {data?.map((v) => (
          <ManageUserCard
            key={v?._id}
            data={v}
            handleDelete={handleDelete}
          />
        ))}
      </div>
    </div>
  );
};

export default ManageUserTable;
